import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JsonFormsAngularService } from '@jsonforms/angular';
import { Actions, JsonSchema } from '@jsonforms/core';
import { ProjectQuery } from 'src/app/projects/state/project.query';

@Injectable({
  providedIn: 'root'
})
export class CustomPropertyService {

  constructor(
    private http: HttpClient,
    private projectQuery: ProjectQuery,
    private jsonformsService: JsonFormsAngularService
  ) { }

  getProjectSchemas() {
    const projectId = this.projectQuery.getActiveId();
    return this.http.get<any>(`/api/project/${projectId}/schemas`);
  }

  getInputTemplates() {
    const projectId = this.projectQuery.getActiveId();
    return this.http.get<any>(`/api/project/${projectId}/input-templates`);
  }

  isValid() {
    const state = this.jsonformsService.getState();
    const erros = state.jsonforms.core.errors;
    return erros && erros.length === 0;
  }

  getData() {
    return this.jsonformsService.getState().jsonforms.core.data;
  }

  loadForm(data: object, schema: JsonSchema) {
    this.jsonformsService.updateCore(
      Actions.init(data, schema)
    );
  }

  clear() {
    this.loadForm({}, {});
  }

}
